import React from 'react';
import { FaCheck } from 'react-icons/fa';

const Pricing: React.FC = () => {
  const features = [
    'Définition de votre cible idéale',
    'Création de vos messages personnalisés',
    'Prospection multi-canal (email, LinkedIn, téléphone)',
    'Suivi et qualification des leads',
    'Rapports de performance hebdomadaires',
    'Optimisation continue des campagnes'
  ];

  return (
    <section id="tarifs" className="py-20 bg-growlyy-gray-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-growlyy-primary mb-4">Nos tarifs</h2>
          <p className="text-xl text-growlyy-gray-dark max-w-2xl mx-auto">
            Une tarification simple et transparente basée sur la performance
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="bg-gradient-growlyy p-8 text-center text-white">
              <h3 className="text-2xl font-bold mb-2">Forfait Prospection à la Performance</h3>
              <p className="text-lg opacity-90 mb-6">Payez uniquement pour les résultats obtenus</p>
              <div className="flex flex-col md:flex-row justify-center items-center gap-8">
                <div className="text-center">
                  <span className="text-4xl font-bold">175€</span>
                  <p className="text-sm opacity-80">/ mois</p>
                </div>
                <div className="text-3xl font-bold">+</div>
                <div className="text-center">
                  <span className="text-4xl font-bold">175€</span>
                  <p className="text-sm opacity-80">Par RDV qualifié et effectué</p>
                </div>
              </div>
            </div>
            
            <div className="p-8">
              <div className="mb-8">
                <h4 className="text-xl font-semibold mb-4 text-growlyy-primary">Ce qui est inclus :</h4>
                <ul className="space-y-3">
                  {features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <FaCheck className="text-growlyy-secondary mt-1 mr-3 flex-shrink-0" />
                      <span className="text-growlyy-gray-dark">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="text-center">
                <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large btn-pulse">
                  Commencer maintenant
                </a>
                <p className="mt-4 text-growlyy-gray-dark text-sm">
                  Aucun engagement de durée - Annulez à tout moment
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing; 